import * as types from "../actions/actionTypes";
import initialState from "./initialState";
import {insertItem, removeItem} from "./helpers";

export default function fileReducer(state = initialState.files, action) {
  switch (action.type) {
    case types.FILES_SUCCESS:
      return action.files;
    case types.FILE_SUCCESS:
      return insertItem(state, action.file);
    case types.DESTROY_FILE_SUCCESS:
      return removeItem(state, action.file);
    default:
      return state;
  }
}
